import { SCROLL_DOWN_MODE, SCROLL_DOWN_MODE_TYPE } from '@utils/constants';
import { useEffect, useState } from 'react';
import styled, { useTheme } from 'styled-components';

import ScrollButton from '../ScrollButton';

const ScrollToTopWrapper = styled.span`
  position: fixed;
  bottom: 7rem;
  right: 4rem;
  cursor: pointer;
  z-index: 3;
`;

interface ScrollToTopProps {
  mode: (typeof SCROLL_DOWN_MODE_TYPE)[number];
}

const ScrollToTop = ({ mode }: ScrollToTopProps) => {
  const theme = useTheme();
  const [showTopBtn, setShowTopBtn] = useState<boolean>(false);

  useEffect(() => {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 200) {
        setShowTopBtn(true);
      } else {
        setShowTopBtn(false);
      }
    });
  }, []);

  const goToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <>
      {showTopBtn && (
        <ScrollToTopWrapper>
          <ScrollButton
            size={3.2}
            backgroundColor={
              mode === SCROLL_DOWN_MODE.LIGHT
                ? theme.color.whiteOp75
                : theme.color.shadeGrey2
            }
            hoverBackgroundColor={
              mode === SCROLL_DOWN_MODE.LIGHT
                ? theme.color.shadeGrey2
                : theme.color.whiteOp75
            }
            color={
              mode === SCROLL_DOWN_MODE.LIGHT
                ? theme.color.shadeGrey2
                : theme.color.white
            }
            hoverColor={
              mode === SCROLL_DOWN_MODE.LIGHT
                ? theme.color.white
                : theme.color.shadeGrey2
            }
            icon="caret_arrow_up"
            onClick={goToTop}
          />
        </ScrollToTopWrapper>
      )}
    </>
  );
};
export default ScrollToTop;
